export interface careerCard {
  id: number;
  name: string;
  title: string;
  description1: string;
  description2?: string;
  imgSrc: string;
  imgAlt: string;
  reverseLayout?: boolean; // optional flag if you want to flip the image/text side
}

// The style for cards with background gradient
export const bgGradientStyle = {
  background:
    "linear-gradient(309.45deg, rgba(0, 167, 89, 0.08) 24.42%, rgba(0, 163, 212, 0.08) 69.56%)",
};

export const bgwhiteStyle = {
  background:
    "white",
};

// Data for leadership cards
export const carrerCardData: careerCard[] = [
  {
    id: 1,
    name: "S Murali Krishna Pasumarthi",
    title: "Chairman & Managing Director",
    description1:
      "Intron Life Sciences provides a professional work environment with significant opportunities for career growth. The organization offers a challenging yet rewarding experience that enables individuals to recognize, develop, and fully utilize their inherent capabilities while achieving their professional goals. Intron strongly promotes a culture of professionalism, integrity, and commitment, with a firm emphasis on ethical business practices and a strict policy against internal politics. Driven by continuous innovation and a strong focus on customer relevance, Intron Life Sciences presents exciting career opportunities and welcomes skilled professionals from diverse functions and specializations to join its growth journey.",
    description2:
      "Interested candidates may mail their CVs to careers@intronlifesciences.com",
    imgSrc: "/img/career/career_img_3.png",
    imgAlt: "career",
    reverseLayout: false,
  },
  // add as many cards as you want...
];
